/**
 * Type-narrowing utilities — avoid casting with `as` (Effective TypeScript §41).
 * Each returns true when the thrown value is an HTTP error with the given response status.
 */
export const is404 = (err: unknown): boolean =>
  typeof err === 'object' &&
  err !== null &&
  'response' in err &&
  (err as { response: { status: number } }).response?.status === 404;

export const is400 = (err: unknown): boolean =>
  typeof err === 'object' &&
  err !== null &&
  'response' in err &&
  (err as { response: { status: number } }).response?.status === 400;

/**
 * Returns true when the thrown value is an HTTP 422 Unprocessable Entity error.
 * Used to detect the backend rejection when attempting to publish an apartment
 * that has no geocoding data (placeId not set via Google Places autocomplete).
 */
export const is422 = (err: unknown): boolean =>
  typeof err === 'object' &&
  err !== null &&
  'response' in err &&
  (err as { response: { status: number } }).response?.status === 422;

